export const ServicesTableColumns = (isArabic) => [
    { id: 'title',      label: isArabic ? 'العنوان'       : 'Title',      align: 'start'  },
    // { id: 'slug',       label: isArabic ? 'الرابط (Slug)' : 'Slug',       align: 'start'  },
    { id: 'image',       label: isArabic ? 'الصورة'        : 'Image',      align: 'center' },
    { id: 'show_in_home', label: isArabic ? 'عرض في الرئيسية' : 'Show in Home', align: 'center' },
    { id: 'created_at', label: isArabic ? 'تاريخ الإضافة' : 'Created At', align: 'start'  },
];